import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fae48cc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog profile-dialog" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "field" }
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "field" }
const _hoisted_6 = {
  disabled: "",
  value: ""
}
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "field" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "btn red" }

import userApi from '@/api/userApi';
import devices from '@/store/device';
import i18, { State as I18State } from '@/store/i18';
import user, { State } from '@/store/user';
import { computed, onMounted, reactive, ref } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit: emits }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const store = useStore();
const i18Data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18Data.value.texts[i18Data.value.lang.list[i18Data.value.lang.now]].login)

const userState = computed<State>(() => store.state[user.name])
const state = reactive({
    password: '',
    qid: '',
    answer: ''
})
const qas = ref<Array<{ id: number, title: string }>>([])


onMounted(() => {
    loadQuestions()
})

async function loadQuestions() {
    qas.value = await userApi.getQas()
}

async function onSubmit() {
    if (!state.password) {
        return devices.toast(store, lang.value.password_placeholder)
    }
    if (!state.qid) {
        return devices.toast(store, lang.value.question_placeholder)
    }
    if (!state.answer) {
        return devices.toast(store, lang.value.answer_placeholder)
    }
    try {
        await userApi.setQa(userApi.token, state.password, state.qid, state.answer)
        if (userState.value.info) {
            userState.value.info.vsq = 1
        }
        devices.toast(store, lang.value.set_success)
        emits('close')
    } catch (e: any) {
        devices.toast(store, e.message)
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", {
      class: "close icon i-guanbi c-thirdary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('close')))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_unref(lang).set_qa), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).password) = $event)),
        type: "password",
        placeholder: _unref(lang).password_placeholder
      }, null, 8, _hoisted_4), [
        [_vModelText, _unref(state).password]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).qid) = $event))
      }, [
        _createElementVNode("option", _hoisted_6, _toDisplayString(_unref(lang).question_placeholder), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(qas.value, (item) => {
          return (_openBlock(), _createElementBlock("option", {
            value: item.id
          }, _toDisplayString(item.title), 9, _hoisted_7))
        }), 256))
      ], 512), [
        [_vModelSelect, _unref(state).qid]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).answer) = $event)),
        placeholder: _unref(lang).answer_placeholder
      }, null, 8, _hoisted_9), [
        [_vModelText, _unref(state).answer]
      ])
    ]),
    _createElementVNode("div", {
      class: "submit",
      onClick: onSubmit
    }, [
      _createElementVNode("a", _hoisted_10, _toDisplayString(_unref(lang).do_ok), 1)
    ])
  ]))
}
}

})